/* eslint-disable no-nested-ternary */
import { Fragment } from 'react';
import { ColumnInstance, Row, TableBodyPropGetter, TableBodyProps } from 'react-table';

import { RowColor } from 'types';

import { Headline } from 'components/Headline';

import * as S from './Body.styles';

type BodyProps = {
  data: readonly {}[];
  getTableBodyProps: (propGetter?: TableBodyPropGetter<{}> | undefined) => TableBodyProps;
  rows: Row<{}>[];
  prepareRow: (row: Row<{}>) => void;
  renderRowSubComponent?: Function;
  renderRowColor?: (row: Row) => RowColor;
  visibleColumns: ColumnInstance<{}>[];
  hasNoRecords?: boolean;
};

const defaultProps: Partial<BodyProps> = {
  hasNoRecords: false,
  renderRowColor: undefined,
};

export function Body(props: BodyProps): React.ReactElement {
  const {
    data,
    getTableBodyProps,
    rows,
    prepareRow,
    renderRowSubComponent,
    visibleColumns,
    hasNoRecords,
    renderRowColor,
  } = { ...defaultProps, ...props };

  const message = hasNoRecords ? 'No Records Found' : 'No Data';

  return (
    <S.Body {...getTableBodyProps()} key={getTableBodyProps().className}>
      {data && data.length > 0 ? (
        rows.map((row) => {
          prepareRow(row);

          return (
            <Fragment key={row.getRowProps().key}>
              <S.TR
                {...row.getRowProps()}
                colors={renderRowColor ? renderRowColor(row) : null}
              >
                {row.cells.map((cell) => (
                  <S.TD {...cell.getCellProps()} key={cell.getCellProps().key}>
                    {cell.value ||
                    cell.value === 0 ||
                    cell.column.id === 'expander' ||
                    cell.value === false
                      ? cell.render('Cell')
                      : ''}
                  </S.TD>
                ))}
              </S.TR>

              {row.isExpanded && renderRowSubComponent ? (
                <tr key={row.getRowProps().key}>
                  <td colSpan={visibleColumns.length}>{renderRowSubComponent(row)}</td>
                </tr>
              ) : null}
            </Fragment>
          );
        })
      ) : (
        <S.TR>
          <S.TD>
            <S.NoData>
              <S.NoDataInner>
                <Headline textAlign="center" scale="xl">
                  {message}
                </Headline>
              </S.NoDataInner>
            </S.NoData>
          </S.TD>
        </S.TR>
      )}
    </S.Body>
  );
}
